import http from './index'

export default {
  // 获取当前首页类型
  getCurrentLayoutType (params) {
    return http.get('/front/layoutSchema/currentLayoutType', params)
  },
  // 获取部件列表
  widgetList (params) {
    return http.get('/front/widget/list', params)
  },
  //  获取模板列表
  schemaWidgetList (params) {
    return http.get('/front/layoutSchema/list', params)
  },
  schemaWidgetInfo (params) {
    return http.get('/front/schemaWidget', params)
  },
  // 修改首页配置(应用)
  apply (params) {
    // if (params.isAdmin) {
    //   return http.post('/front/userWidget/save/', params.list);
    // }
    return http.post('/front/userWidget/save', params)
  },
  // 获取首页配置信息
  userWidget (params) {
    return http.get('/front/userWidget/', params)
  },

  // 保存配置为模板
  save (params) {
    return http.post('/front/schemaWidget/save', params)
  },

  //  配置另存为模板
  saveNew (params) {
    return http.post('/front/schemaWidget/save/new', params)
  },
  saveCustomMould (params) {
    return http.post('/front/schemaWidget/save/custom', params)
  },
  // 删除模板
  delMould (params) {
    return http.post('/front/layoutSchema/delete', params)
  },
  // 获取首页远端加载小部件
  getWaterfallList (params) {
    return http.get('/front/widget/listwaterfall', params)
  }
}
